import ConnectedDataTable from './DataTable';

export default ConnectedDataTable;



// WEBPACK FOOTER //
// ./src/app/components/DataTable/index.js